import React from "react";
import { FormattedMessage } from "react-intl";

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer bg-white py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer"
      >
        {/* begin::Container */}
        <div
          className={`${footerContainerClasses}`}
        >
          {/* end::Copyright */}
          {` `}
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2 mb-4 justify-content-center">
            <a
              href="https://registry.agilesolutions.az/qualitymark"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              <FormattedMessage id="qualitymark" />
            </a>
            <a
              href="https://registry.agilesolutions.az/faq"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              <FormattedMessage id="faq" />
            </a>
            {/* <a
              href="https://registry.agilesolutions.az/missions"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              <FormattedMessage id="mission"/>
            </a>
            <a
              href="https://registry.agilesolutions.az/advantages"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              <FormattedMessage id="grading"/>
            </a> */}
            <a
              href="https://tourism.gov.az/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              Tourism.gov.az
            </a>
            <a
              href="https://www.tourismboard.az/az"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              Tourismboard.az
            </a>
            <a
              href="https://azerbaijan.travel/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              Azerbaijan.travel
            </a>
            <a
              href="https://meetinazerbaijan.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              Meetinazerbaijan.com
            </a>
          </div>

          <div className="text-dark order-2 order-md-1 text-center">
            <span className="text-muted font-weight-bold mr-2">
              {today} &copy;
            </span>
            {` `}
            <a
              href="https://registry.agilesolutions.az/"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              <FormattedMessage id="tourism_registry" />
            </a>
          </div>
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
    </>
  );
}
